import React, { useContext, useEffect, useState } from 'react';
import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';
import './processing.css'



const ProcessingPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);



    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 5000);
    }, []);

    useEffect(() => {

        const company = process.env.REACT_APP_COMPANY;
        let url = logo;



        setLogoUrl(url);
    }, []);



    return (
        <div>
            {
                (
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border  text-info mt-5" role="status">
                            <span className="visually-hidden">Procesando...</span>
                        </div>
                    </div>
                )
            }

        </div>



    );
};




export default ProcessingPage;
